export const HIDE_PROFILE_MODAL = 'HIDE_PROFILE_MODAL';

export default function hideProfileModal() {
    return {
        type: HIDE_PROFILE_MODAL,
    };
}
